import { useEffect, useState, SVGProps, useRef } from "react";
import OrderHeaderTickIcon from "../../assets/svg/OrderHeaderTickIcon";
import dataConstants from "../../constants/dataConstants";
import useQueryParams from "../../services/utils/custom hooks/QueryHelper";
import useMobile from "../../utils/helpers/useMobile";
import CustomText from "../atomic/CustomText";
import LeftArrow from "../../assets/svg/LeftArrow";
import RightArrow from "../../assets/svg/RightArrow";

const ValidMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={11}
    fill="none"
    {...props}
  >
    <path
      stroke="#18B5B7"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.667 1 5.5 10.167 1.333 6"
    />
  </svg>
);

interface StatusHeaderProps {
  status: number;
  selectedTab?: string;
}

interface StatusItemProps {
  label: string;
  valid: boolean;
  hideRightBorder: boolean;
  isCancel: boolean;
  isCurrentStep?: boolean;
}

function StatusItemNew({
  label,
  valid,
  hideRightBorder,
  isCancel,
  isCurrentStep,
}: Readonly<StatusItemProps>): JSX.Element {
  return (
    <div
      className={`flex flex-col h-[55px] px-4 ${
        !hideRightBorder ? "w-[140px]" : ""
      } relative`}
    >
      <div
        className={`h-8 w-8 rounded-full flex-shrink-0 border-2 ${
          valid || isCurrentStep ? "border-primary" : "border-[#DADEE3]"
        } flex flex-col justify-center items-center`}
      >
        {valid ? (
          <ValidMark />
        ) : (
          <div
            className={`h-[10px] w-[10px] ${
              isCurrentStep ? "bg-primary" : "bg-inactiveGray"
            } rounded-full`}
          />
        )}
      </div>
      <CustomText
        text={label}
        fontWeight="font-medium"
        fontSize="text-xs"
        className={`${valid ? "text-primary" : "text-royalBlue"} mt-2 w-full `}
      />
      {!hideRightBorder && (
        <div
          className={`w-[calc(100%_-_23%)] ${
            valid ? "bg-primary" : "bg-inactiveGray"
          } h-[2px] absolute top-4 -right-4 `}
        />
      )}
    </div>
  );
}

function MobileStatusHeader({
  statuses,
  selectedTab,
}: Readonly<{ statuses: any[]; selectedTab?: string }>): JSX.Element {
  const divRef = useRef<any>(null);
  const [scrollInterval, setScrollInterval] = useState<any>(null);

  const startScrolling = (direction: "left" | "right") => {
    if (divRef.current) {
      const interval = setInterval(() => {
        divRef.current.scrollBy({
          left: direction === "right" ? 100 : -100, // scroll step
          behavior: "smooth",
        });
      }, 50); // interval speed
      setScrollInterval(interval);
    }
  };

  const stopScrolling = () => {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      setScrollInterval(null);
    }
  };
  return (
    <div
      className={`${
        selectedTab !== "additional-info" &&
        "lg:sticky lg:top-0 bg-white lg:z-20 border border-white mb-5 overflow-hidden w-full"
      }`}
    >
      <div
        ref={divRef}
        className="flex flex-shrink-0 justify-between items-center overflow-auto no-scrollbar"
      >
        <div className="flex flex-shrink-0 items-center justify-center min-h-[90px]">
          <button
            type="button"
            onMouseDown={() => startScrolling("left")}
            onMouseUp={stopScrolling}
            onMouseLeave={stopScrolling}
            disabled={false}
            className={
              "hover:bg-lightGray sticky left-0 bg-white min-h-[90px]  p-2 z-10"
            }
          >
            <LeftArrow />
          </button>
          {statuses.map((status, index) => (
            <StatusItemNew
              label={status.label}
              hideRightBorder={status.label === "Completed"}
              valid={status.valid}
              isCurrentStep={!status.valid && statuses[index - 1]?.valid}
              key={status.label}
              isCancel={false}
            />
          ))}
          <button
            type="button"
            onMouseDown={() => startScrolling("right")}
            onMouseUp={stopScrolling}
            onMouseLeave={stopScrolling}
            disabled={false}
            className={
              "hover:bg-lightGray sticky right-0 bg-white min-h-[90px]  p-2 z-10"
            }
          >
            <RightArrow />
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileStatusHeader;
